import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { heroImage, included, price } from '../data/copy';
const assurances = ['Secure payment', 'Immediate digital access', 'Ready-to-use PDFs'];
export function OfferSection() {
  return <section id="offer" className="defer-paint w-full scroll-mt-6 bg-sage-deep py-11 sm:py-14" aria-labelledby="offer-heading" data-id="element-128" data-mp="dex2qh19cqc4">
      <div className="mx-auto max-w-5xl px-6" data-id="element-129" data-mp="ifb09558ghvw">
        <CountdownTimer data-id="element-130" data-mp="meaan59qh6uq" />

        <div className="mx-auto mt-9 max-w-2xl text-center" data-id="element-131" data-mp="mdiffvk1tb4z">
          <p className="eyebrow text-gold-soft" data-id="element-132" data-mp="rdem62k4rgo8">The complete package</p>
          <h2 id="offer-heading" className="mt-4 font-display text-[2rem] leading-[1.12] text-ivory sm:text-4xl" data-id="element-133" data-mp="rc3j64yiecy6">
            Get the complete Yoga Teaching Vault™ today
          </h2>
        </div>

        <div className="mt-7 grid gap-8 rounded-4xl bg-shell p-6 shadow-lift sm:p-9 lg:grid-cols-[0.95fr_1.05fr] lg:gap-10" data-id="element-134" data-mp="2t7m8sbdq8va0">
          <div className="flex flex-col" data-id="element-135" data-mp="12o1ur0x94y6z">
            <div className="rounded-3xl bg-sand p-5 sm:p-7" data-id="element-136" data-mp="12p35136g1gnn">
              <img src={heroImage} alt="Everything included: six teaching volumes, seven bonus books and printable teaching resources." className="mx-auto w-full max-w-sm" width={1240} height={1240} sizes="384px" loading="lazy" decoding="async" data-id="element-137" data-mp="xwa1gimpoed5" />
            </div>

            <div className="mt-6 rounded-3xl border border-gold/40 bg-gold-soft/40 px-6 py-7 text-center" data-id="element-138" data-mp="ouaihks4z07k">
              <p className="eyebrow text-gold-ink" data-id="element-139" data-mp="1gn9wa0gw0iec">Get complete access today</p>
              <p className="mt-2 flex items-start justify-center gap-1 font-display text-[3.5rem] leading-none text-ink" data-id="element-140" data-mp="1gl6wiopxnawf">
                <span className="mt-2.5 text-2xl" data-id="element-141" data-mp="17mlhv4nl0g0x">$</span>27
              </p>
              <p className="mt-2 font-sans text-xs uppercase tracking-[0.16em] text-stone" data-id="element-142" data-mp="17opindq6oywz">
                USD · one payment · 100% digital
              </p>
            </div>

            <CtaButton size="large" className="mt-5 w-full" data-id="element-143" data-mp="3sb98scm67kuh">
              Get instant access — {price}
            </CtaButton>

            <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-144" data-mp="3ts6kaqbozoem">
              {assurances.map(item => <li key={item} className="flex items-center gap-1.5 font-sans text-[11px] text-stone" data-id="element-145" data-mp="3ktl4h2xlunhj">
                  <CheckIcon className="h-3.5 w-3.5 text-sage" strokeWidth={2.4} aria-hidden="true" data-id="element-146" data-mp="3oumviwhdbt8f" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div data-id="element-147" data-mp="3b1osqp2liyuu">
            <p className="eyebrow text-sage-deep" data-id="element-148" data-mp="3ftyhi1rz5svj">Everything included</p>
            <ul className="mt-6 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-149" data-mp="3fwb3qr4rmpee">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 font-sans text-[0.88rem] leading-relaxed text-ink/85" data-id="element-150" data-mp="31393krn4pznz">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-sage" strokeWidth={2.4} aria-hidden="true" data-id="element-151" data-mp="2s4nqhc0ffcul" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-8 rounded-3xl bg-sand px-6 py-7" data-id="element-152" data-mp="2x5jppc9u2ato">
              <h3 className="font-display text-xl leading-snug text-ink" data-id="element-153" data-mp="2diqavnqet8yn">
                Think about what one hour of your planning time is worth.
              </h3>
              <p className="mt-4 font-sans text-sm leading-relaxed text-stone" data-id="element-154" data-mp="2mj4y4smxoy4s">
                One hour this week. Another next week. Another the week after.
                The value of the Vault isn’t simply the number of PDFs inside —
                it’s the planning you may no longer need to do from zero.
              </p>
              <p className="mt-4 font-sans text-sm leading-relaxed text-ink" data-id="element-155" data-mp="2rgx0kgl7g2n8">
                And every time you reuse the Vault, the system becomes more
                valuable.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}